//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const DetermineDatasourceTotalRecordCount: FeatureFlag = {"Id":"DetermineDatasourceTotalRecordCount","Label":"[10.13] Determine total record count for datasources","Impact":"When @odata.count is not returned by an OData endpoint, this will retrieve all data to determine the total count which most likely will affect performance.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
